import { gsap } from 'gsap';
const id = 'backdrop';

const initBackdrop = function () {
  $('body').append(
    $(`
      <div id="${id}"></div>
      <style>
          #${id} {
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              opacity: 0;
              visibility: hidden;
              background-color: rgba(0,0,0, 0.3);
              transition: opacity .1s, visibility .1s;
              z-index: 11;
          }
      </style>
  `),
  );

  $(`#${id}`).on('click', function () {
    const $openCountrySwitcher = $('.lang-switcher__modal.open');
    if ($openCountrySwitcher.length) {
      $openCountrySwitcher.removeClass('open');
    }

    const $openLangSwitcher = $('.country-switcher__modal.open');
    if ($openLangSwitcher.length) {
      $openLangSwitcher.removeClass('open');
    }

    const $openMinicart = $('.minicart__drawer.minicart__drawer--open');
    if ($openMinicart.length) {
      $openMinicart.removeClass('minicart__drawer--open');
    }

    hideBackdrop();
  });
};

const showBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 1, duration: 0.1 });
};

const hideBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 0, duration: 0.1 });
};

export { showBackdrop, hideBackdrop, initBackdrop };
